import { PayloadAction } from "@reduxjs/toolkit";
import { gerenciaTecnicaState } from "./interfaces";

export const reducers = {
    setActivitiesWithCarts: (
        state: gerenciaTecnicaState,
        action: PayloadAction<any[]>
    ) => {
        state.activitiesWithCarts = action.payload;
    },
    setCardsWithActivities: (
        state: gerenciaTecnicaState,
        action: PayloadAction<any[]>
    ) => {
        state.cardsWithActivities = action.payload;
    },
    setTaskValidations: (
        state: gerenciaTecnicaState,
        action: PayloadAction<any[]>
    ) => {
        state.taskValidations = action.payload;
    },
    setLocations: (
        state: gerenciaTecnicaState,
        action: PayloadAction<any[]>
    ) => {
        state.locations = action.payload;
    },
    setUsers: (state: gerenciaTecnicaState, action: PayloadAction<any[]>) => {
        state.users = action.payload;
    },
    setUploadingStep: (
        state: gerenciaTecnicaState,
        action: PayloadAction<string>
    ) => {
        state.uploadingStep = action.payload;
    },
    setTasksList: (state: gerenciaTecnicaState, action: PayloadAction<any>) => {
        state.taskList = action.payload?.tasks || [];
        state.totalActivities = action.payload?.total || 0;
    },
    setReportsList: (
        state: gerenciaTecnicaState,
        action: PayloadAction<any>
    ) => {
        state.reportsList = action.payload;
    },
    setReportData: (
        state: gerenciaTecnicaState,
        action: PayloadAction<any>
    ) => {
        state.reportWithData = action.payload;
    },
    emptyReportData: (state: gerenciaTecnicaState) => {
        state.reportWithData = [];
    },
    setReportFilter: (
        state: gerenciaTecnicaState,
        action: PayloadAction<any>
    ) => {
        state.reportFilters = action.payload;
    },
    setLocationListFilter: (
        state: gerenciaTecnicaState,
        action: PayloadAction<any>
    ) => {
        state.locationListFilter = action.payload;
    },
};
